<template>
  <div class="dashboard-page">
    <section class="dashboard-hero">
      <div class="hero-mesh" aria-hidden="true" />
      <div class="hero-glow" aria-hidden="true" />
      <div class="hero-grid">
        <div class="hero-copy">
          <p class="hero-eyebrow">
            <span class="hero-eyebrow-dot" aria-hidden="true" />
            {{ t('dashboard.hero.eyebrow') }}
          </p>
          <h1 class="hero-title">
            {{ userFirstName ? t('dashboard.hero.welcomeUser', { name: userFirstName }) : t('dashboard.hero.welcome') }}
          </h1>
          <p class="hero-subtitle">
            {{ t('dashboard.hero.subtitle') }}
          </p>
          <div class="hero-chips">
            <span class="hero-chip">
              <svg class="hero-chip__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
              </svg>
              {{ t('estruturacao.heroAreaCommercial') }}
            </span>
            <span class="hero-chip">
              <svg class="hero-chip__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              {{ t('estruturacao.heroAreaService') }}
            </span>
            <span class="hero-chip">
              <svg class="hero-chip__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              {{ t('estruturacao.heroAreaOperational') }}
            </span>
            <span class="hero-chip hero-chip--accent">
              <svg class="hero-chip__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {{ t('estruturacao.heroAreaFinancial') }}
            </span>
          </div>

          <div v-show="SHOW_ESTRUTURACAO_UI" class="hero-estrut-promo">
            <div class="hero-estrut-promo__visual">
              <span class="hero-estrut-promo__role" aria-hidden="true">{{ t('estruturacao.heroRoleLabel') }}</span>
              <img
                :src="estruturacaoHeroImage"
                :alt="t('estruturacao.heroAlt')"
                class="hero-estrut-promo__portrait"
              />
            </div>
            <div class="hero-estrut-promo__body">
              <p class="hero-estrut-promo__eyebrow">
                <span class="hero-estrut-promo__eyebrow-dot" aria-hidden="true" />
                {{ t('dashboard.hero.estruturacaoPromoEyebrow') }}
              </p>
              <h3 class="hero-estrut-promo__title">
                {{ t('dashboard.hero.estruturacaoPromoTitle') }}
                <span class="hero-estrut-promo__title-accent">{{ t('dashboard.hero.estruturacaoPromoTitleAccent') }}</span>
              </h3>
              <p class="hero-estrut-promo__text">{{ t('dashboard.hero.estruturacaoPromoText') }}</p>
              <span class="hero-estrut-promo__badge">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                {{ t('dashboard.hero.estruturacaoPromoChipMethodology') }}
              </span>
              <RouterLink to="/estruturacao" class="hero-estrut-promo__btn">
                <span>{{ t('dashboard.hero.estruturacaoPromoCta') }}</span>
                <svg class="hero-estrut-promo__btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </RouterLink>
            </div>
          </div>
        </div>
        <div class="hero-brand">
          <div class="hero-logo-wrap">
            <img :src="dashboardLogo" :alt="t('dashboard.hero.logoAlt')" class="hero-logo" />
          </div>
        </div>
      </div>
      <div class="hero-stats">
        <div class="hero-stat-card">
          <div class="hero-stat-icon hero-stat-icon--indigo" aria-hidden="true">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
            </svg>
          </div>
          <div class="hero-stat-body">
            <span class="hero-stat-label">{{ t('dashboard.stats.workspaces') }}</span>
            <span class="hero-stat-value">{{ workspaces.length }}</span>
          </div>
        </div>
        <div class="hero-stat-card hero-stat-card--plan">
          <div class="hero-stat-icon hero-stat-icon--violet" aria-hidden="true">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
            </svg>
          </div>
          <div class="hero-stat-body">
            <span class="hero-stat-label">{{ t('dashboard.stats.activePlan') }}</span>
            <span class="hero-stat-value hero-stat-value--plan">
              {{ planoDisplayTitle }}
              <span v-if="planoDisplaySubtitle" class="hero-stat-plan-sub">{{ planoDisplaySubtitle }}</span>
            </span>
          </div>
        </div>
      </div>
    </section>

    <section class="workspace-panel">
      <header class="workspace-panel-header">
        <div class="workspace-panel-heading">
          <div class="workspace-panel-icon" aria-hidden="true">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
            </svg>
          </div>
          <div>
            <h2 class="workspace-panel-title">{{ t('dashboard.panel.title') }}</h2>
            <p class="workspace-panel-subtitle">{{ t('dashboard.panel.subtitle') }}</p>
          </div>
        </div>
        <span v-if="workspaces.length > 0" class="workspace-count-badge">
          {{ workspaces.length === 1
            ? t('dashboard.panel.availableOne', { count: workspaces.length })
            : t('dashboard.panel.availableOther', { count: workspaces.length }) }}
        </span>
      </header>

      <p v-if="workspaces.length === 0" class="workspace-gallery-hint">
        {{ t('dashboard.panel.emptyHint') }}
      </p>

      <div class="workspace-gallery">
        <button
          v-for="workspace in workspaces"
          :key="workspace.id"
          type="button"
          class="workspace-card"
          :class="{ 'workspace-card--active': currentWorkspace?.id === workspace.id }"
          :style="{ '--tile-accent': workspace.corWorkspace || '#6366f1' }"
          @click="handleSelectWorkspace(workspace)"
        >
          <div
            class="workspace-card__media"
            :style="workspace.fotoWorkspace && workspace.fotoWorkspace.trim() !== '' ? {} : { backgroundColor: workspace.corWorkspace || 'var(--info)', color: '#fff' }"
          >
            <img
              v-if="workspace.fotoWorkspace && workspace.fotoWorkspace.trim() !== ''"
              :src="workspace.fotoWorkspace"
              :alt="workspace.nome"
              class="workspace-card__photo"
              @error="handleImageError"
            />
            <component v-else :is="getIconComponent(workspace.icone)" class="w-10 h-10" />
          </div>
          <div class="workspace-card__body">
            <p class="workspace-card__title">{{ workspace.nome }}</p>
            <span class="workspace-card__badge" :class="workspace.tipo === 'CRM' ? 'workspace-card__badge--crm' : 'workspace-card__badge--task'">
              {{ workspaceTypeLabel(workspace.tipo) }}
            </span>
          </div>
          <div class="workspace-card__footer" aria-hidden="true">
            <span class="workspace-card__cta">{{ t('dashboard.panel.enter') }}</span>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
            </svg>
          </div>
        </button>

        <button
          type="button"
          class="workspace-card workspace-card--create"
          :class="{ 'workspace-card--create-disabled': workspaceCreateBlocked }"
          :title="workspaceCreateBlocked ? t('createWorkspace.limit.adminHint') : t('dashboard.panel.createTitle')"
          :disabled="workspaceCreateBlocked"
          @click="handleCreateWorkspace"
        >
          <div class="workspace-card__media workspace-card__media--create">
            <div class="workspace-card-create-icon" aria-hidden="true">
              <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
              </svg>
            </div>
            <div class="workspace-card-create-glow" aria-hidden="true" />
          </div>
          <div class="workspace-card__body">
            <p class="workspace-card__title">{{ t('dashboard.panel.newWorkspace') }}</p>
            <span class="workspace-card__badge workspace-card__badge--new">{{ t('dashboard.panel.createBadge') }}</span>
          </div>
          <div class="workspace-card__footer workspace-card__footer--create">
            <span class="workspace-card__cta">{{ t('dashboard.panel.add') }}</span>
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
            </svg>
          </div>
        </button>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from 'vue'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../stores/auth'
import { useWorkspaceStore } from '../stores/workspace'
import { useThemeStore } from '../stores/theme'
import { useGlobalWorkspaces } from '../composables/useGlobalWorkspaces'
import { normalizePlanoCodigo } from '../constants/planFeatures'
import { getPlanDisplay } from '../constants/planDisplayCatalog'
import Swal from 'sweetalert2'
import api from '../services/api'
import { useAccountAccessBlock, setOwnerAccessBlocked } from '../composables/useAccountAccessBlock'
import { h } from 'vue'
import heroDark from '../assets/estruturacao/édipo Oliveira.png'
import heroLight from '../assets/estruturacao/édipo Oliveira 2.png'
import { SHOW_ESTRUTURACAO_UI } from '../constants/estruturacaoSections'

const { t } = useI18n()

const PLAN_LOCALE_KEYS = {
  FREE: 'free',
  START_VERIFICADO: 'start',
  PRO_VERIFICADO: 'pro',
  CORPORATIVO: 'corporate'
}

// Inicializar themeStore (sempre disponível)
const themeStore = useThemeStore()

// Inicializar stores com tratamento de erro
let authStore, workspaceStore
try {
  authStore = useAuthStore()
  workspaceStore = useWorkspaceStore()
  
  // Garantir que o workspaceStore tenha a propriedade workspaces
  if (!workspaceStore.workspaces) {
    console.error('❌ WorkspaceStore não tem propriedade workspaces')
  } else {
    console.log('✅ WorkspaceStore inicializado:', workspaceStore.workspaces.value)
  }
} catch (error) {
  console.error('Erro ao inicializar stores:', error)
  // Fallback para evitar quebrar a aplicação
  authStore = { token: localStorage.getItem('token'), user: null }
  workspaceStore = { workspaces: { value: [] }, getUserWorkspaces: async () => [] }
}

// Usar workspaces globais
const { 
  workspaces, 
  currentWorkspace, 
  isHome, 
  selectWorkspace, 
  goHome, 
  updateWorkspaceInList,
  removeWorkspaceFromList
} = useGlobalWorkspaces()

const openCreateWorkspaceModal = inject('openCreateWorkspaceModal', () => {
  console.warn('[DashboardPage] openCreateWorkspaceModal não disponível')
})

const accountBlock = useAccountAccessBlock()

const handleSelectWorkspace = (workspace) => {
  if (accountBlock.isSelfBlocked.value) {
    setOwnerAccessBlocked(false)
    accountBlock.openInPageBlock()
    return
  }
  if (workspace?.criador?.acessoBloqueado) {
    setOwnerAccessBlocked(true)
    accountBlock.openInPageBlock()
    return
  }
  setOwnerAccessBlocked(false)
  selectWorkspace(workspace)
}

const handleCreateWorkspace = () => {
  if (accountBlock.isSelfBlocked.value) {
    accountBlock.openInPageBlock()
    return
  }
  openCreateWorkspaceModal()
}

const workspaceCreateBlocked = ref(false)

const loadWorkspaceCreationLimit = async () => {
  try {
    const { data } = await api.get('/planos/criacao-limites')
    const total = data?.total || {}
    workspaceCreateBlocked.value = total.max != null && total.max >= 0 && Boolean(total.blocked)
  } catch {
    workspaceCreateBlocked.value = false
  }
}

const dashboardLogo = computed(() => (themeStore.isLight ? '/logo_b.png' : '/logo_w.png'))
const estruturacaoHeroImage = computed(() => (themeStore.isLight ? heroLight : heroDark))

const planoCodigo = ref('')
const planoLoading = ref(true)

const planDisplay = computed(() => getPlanDisplay(planoCodigo.value))

const resolvedPlanoCodigo = computed(() => {
  return planoCodigo.value || normalizePlanoCodigo(authStore?.user?.planoCodigo) || 'FREE'
})

const planoDisplayTitle = computed(() => {
  if (planoLoading.value) return '…'
  const slug = PLAN_LOCALE_KEYS[resolvedPlanoCodigo.value]
  if (slug) return t(`dashboard.plans.${slug}.title`)
  return planDisplay.value?.title || t('dashboard.plans.free.title')
})

const planoDisplaySubtitle = computed(() => {
  const slug = PLAN_LOCALE_KEYS[resolvedPlanoCodigo.value]
  if (slug) {
    const subtitle = t(`dashboard.plans.${slug}.subtitle`)
    return subtitle || null
  }
  return planDisplay.value?.subtitle || null
})

const workspaceTypeLabel = (tipo) => {
  if (tipo === 'CRM') return t('dashboard.workspaceType.crm')
  if (tipo === 'TAREFAS' || tipo === 'TASK') return t('dashboard.workspaceType.task')
  return tipo || t('dashboard.workspaceType.task')
}

const loadMeuPlano = async () => {
  planoLoading.value = true
  try {
    const { data } = await api.get('/planos/meu-plano')
    const codigo = normalizePlanoCodigo(data?.codigo)
    planoCodigo.value = codigo
    if (codigo && authStore?.updateUser) {
      authStore.updateUser({ planoCodigo: codigo })
    }
  } catch (error) {
    console.warn('[DASHBOARD] Erro ao carregar plano:', error)
    planoCodigo.value = normalizePlanoCodigo(authStore?.user?.planoCodigo)
  } finally {
    planoLoading.value = false
  }
}

const userFirstName = computed(() => {
  const name = authStore?.user?.nomeCompleto || authStore?.user?.nome || ''
  const first = String(name).trim().split(/\s+/)[0]
  return first || ''
})

// Ícones SVG como componentes
const TaskIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
      })
    ])
  }
}

const UsersIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z'
      })
    ])
  }
}

const FolderIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z'
      })
    ])
  }
}

const BriefcaseIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6'
      })
    ])
  }
}

const ChartIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
      })
    ])
  }
}

const LightbulbIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
      })
    ])
  }
}

const HeartIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z'
      })
    ])
  }
}

const StarIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z'
      })
    ])
  }
}

const RocketIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5'
      })
    ])
  }
}

const ShieldIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
      })
    ])
  }
}

const CogIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z'
      }),
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z'
      })
    ])
  }
}

const LetterIcon = {
  render() {
    return h('svg', {
      fill: 'none',
      stroke: 'currentColor',
      viewBox: '0 0 24 24',
      class: 'w-6 h-6'
    }, [
      h('path', {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        'stroke-width': '2',
        d: 'M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
      })
    ])
  }
}

// Função para obter o componente de ícone correto
const getIconComponent = (iconName) => {
  const iconMap = {
    'task': TaskIcon,
    'users': UsersIcon,
    'folder': FolderIcon,
    'briefcase': BriefcaseIcon,
    'chart': ChartIcon,
    'lightbulb': LightbulbIcon,
    'heart': HeartIcon,
    'star': StarIcon,
    'rocket': RocketIcon,
    'shield': ShieldIcon,
    'cog': CogIcon,
    'letter': LetterIcon
  }
  
  return iconMap[iconName] || LetterIcon
}

// Função para tratar erro de carregamento de imagem
const handleImageError = (event) => {
  console.log('Erro ao carregar imagem, usando ícone como fallback')
  event.target.style.display = 'none'
}


console.log('📄 DashboardPage script carregado')

// Funções de modal agora estão no App.vue

const handleWorkspaceCreated = async (workspace) => {
  console.log('🎉 Workspace criado com sucesso:', workspace)
  
  // Sincronizar workspaces do store para garantir consistência
  await workspaceStore.syncWorkspaces()
  
  // Atualizar a lista local também
  await loadWorkspaces()
  
  // Selecionar o workspace recém-criado
  selectWorkspace(workspace)
  
  console.log('✅ Dashboard atualizado com novo workspace')
}


const handleWorkspaceUpdated = async (workspace) => {
  console.log('🎉 Workspace atualizado com sucesso:', workspace)
  
  // Modal será fechado automaticamente pelo App.vue
  
  // Recarregar workspaces diretamente da API (mais confiável)
  await loadWorkspaces()
  console.log('🔄 Workspaces recarregados após edição')
  
  // Workspace atualizado na lista local
  
  console.log('✅ Dashboard atualizado com workspace editado')
}

const handleDeleteWorkspace = async (workspace) => {
  const result = await Swal.fire({
    title: t('dashboard.delete.confirmTitle'),
    html: `
      <div class="text-left">
        <p class="mb-3">${t('dashboard.delete.confirmIntro')}</p>
        <div class="flex items-center mb-4">
          <div 
            class="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold text-lg mr-3"
            style="background-color: ${workspace.corWorkspace || '#5865F2'}"
          >
            ${workspace.nome.charAt(0).toUpperCase()}
          </div>
          <div>
            <p class="font-semibold text-lg">${workspace.nome}</p>
            <p class="text-sm text-gray-600">${workspaceTypeLabel(workspace.tipo)}</p>
          </div>
        </div>
        <p class="text-red-600 font-medium">${t('dashboard.delete.cannotUndo')}</p>
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#6b7280',
    confirmButtonText: t('dashboard.delete.confirmButton'),
    cancelButtonText: t('common.cancel'),
    customClass: {
      popup: 'swal2-popup-custom',
      title: 'swal2-title-custom',
      htmlContainer: 'swal2-html-container-custom'
    }
  })

  if (result.isConfirmed) {
    try {
      const deleteResult = await workspaceStore.deleteWorkspace(workspace.id)
      if (deleteResult.success) {
        // Workspace deletado com sucesso
        await Swal.fire({
          title: t('dashboard.delete.deletedTitle'),
          text: t('dashboard.delete.deletedText'),
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        })
      }
    } catch (error) {
      await Swal.fire({
        title: t('dashboard.delete.errorTitle'),
        text: t('dashboard.delete.errorText'),
        icon: 'error'
      })
    }
  }
}

// Workspace handlers já estão no composable global

const handleReorderWorkspaces = (newOrder) => {
  try {
    // Atualizar a lista local de workspaces com a nova ordem
    workspaces.value = newOrder
    console.log('✅ Workspaces reordenados localmente:', newOrder.length, 'workspaces')
  } catch (error) {
    console.error('Erro ao reordenar workspaces:', error)
  }
}

// loadWorkspaces agora é global, não precisa mais aqui

onMounted(async () => {
  console.log('=== [DASHBOARD] DashboardPage montado ===')
  console.log('[DASHBOARD] Workspaces atuais:', workspaces.value.length)
  console.log('[DASHBOARD] isAuthenticated:', authStore?.isAuthenticated)
  
  // Carregar dados do usuário apenas se necessário
  if (authStore?.token && authStore?.fetchUser && !authStore.user) {
    console.log('[DASHBOARD] Carregando dados do usuário...')
    try {
      await authStore.fetchUser()
      console.log('[DASHBOARD] ✅ Usuário carregado')
    } catch (error) {
      console.error('[DASHBOARD] ❌ Erro ao carregar usuário:', error)
    }
  }
  
  // Garantir que workspaces estão carregados (failsafe)
  // Se não há workspaces e usuário está autenticado, carregar
  if (authStore?.isAuthenticated && workspaces.value.length === 0) {
    console.log('[DASHBOARD] ⚠️ Sem workspaces, forçando carregamento...')
    const { loadWorkspaces } = useGlobalWorkspaces()
    await loadWorkspaces(true) // Force reload
    console.log('[DASHBOARD] ✅ Workspaces carregados:', workspaces.value.length)
  } else {
    console.log('[DASHBOARD] ✅ Workspaces já disponíveis:', workspaces.value.length)
  }
  
  await loadMeuPlano()
  await loadWorkspaceCreationLimit()

  console.log('=== [DASHBOARD] Fim do mounted ===')
})
</script>

<style scoped>
.dashboard-page {
  padding: 24px;
  max-width: 100%;
  box-sizing: border-box;
}

.dashboard-hero {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  padding: 40px 0 36px 40px;
  margin-bottom: 28px;
  min-height: 660px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid color-mix(in srgb, var(--accent-primary, #6366f1) 22%, var(--border, var(--border-primary)));
  background:
    radial-gradient(ellipse 90% 70% at 0% 0%, color-mix(in srgb, #6366f1 16%, transparent), transparent 55%),
    radial-gradient(ellipse 70% 60% at 100% 100%, color-mix(in srgb, #8b5cf6 12%, transparent), transparent 50%),
    linear-gradient(165deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.06) inset,
    0 28px 64px rgba(15, 23, 42, 0.14);
}

.hero-mesh {
  position: absolute;
  inset: 0;
  opacity: 0.5;
  background-image:
    linear-gradient(color-mix(in srgb, var(--border, #334155) 35%, transparent) 1px, transparent 1px),
    linear-gradient(90deg, color-mix(in srgb, var(--border, #334155) 35%, transparent) 1px, transparent 1px);
  background-size: 28px 28px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 40%, black 20%, transparent 75%);
  pointer-events: none;
}

.hero-glow {
  position: absolute;
  top: -40%;
  right: -10%;
  width: 55%;
  height: 120%;
  background: radial-gradient(circle, color-mix(in srgb, #6366f1 22%, transparent), transparent 65%);
  pointer-events: none;
}

.hero-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 546px);
  gap: 12px 24px;
  align-items: start;
  align-content: start;
  flex: 0 0 auto;
  width: 100%;
  margin-bottom: 0;
  padding-right: 12px;
}

.hero-copy {
  text-align: left;
  align-self: start;
  justify-self: start;
  min-width: 0;
  padding: 0;
  margin: 0;
}

.hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--accent-primary, #6366f1) 80%, var(--text-secondary));
}

.hero-eyebrow-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.65);
}

.hero-title {
  margin: 0 0 10px;
  font-size: clamp(1.65rem, 2.5vw, 2.15rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: var(--text-primary);
}

.hero-title span {
  color: color-mix(in srgb, var(--accent-primary, #6366f1) 85%, var(--text-primary));
}

.hero-subtitle {
  margin: 0 0 18px;
  max-width: 36rem;
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-secondary);
}

.hero-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  background: color-mix(in srgb, var(--bg-primary) 88%, transparent);
  border: 1px solid var(--border, var(--border-primary));
}

.hero-chip__icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  opacity: 0.88;
}

.hero-chip--accent .hero-chip__icon {
  opacity: 1;
}

.hero-chip--accent {
  color: #fff;
  border-color: transparent;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
}

.hero-estrut-promo {
  display: flex;
  align-items: center;
  gap: 28px;
  margin-top: 28px;
  padding: 0;
}

.hero-estrut-promo__visual {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 1.25rem;
}

.hero-estrut-promo__role {
  position: absolute;
  left: -0.15rem;
  top: 50%;
  transform: translateY(-50%);
  writing-mode: vertical-rl;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--accent-primary, #6366f1) 55%, var(--text-tertiary));
  opacity: 0.85;
  user-select: none;
}

.hero-estrut-promo__portrait {
  display: block;
  width: 216px;
  height: auto;
  user-select: none;
  -webkit-user-drag: none;
  filter: drop-shadow(0 12px 28px color-mix(in srgb, var(--accent-primary, #6366f1) 18%, transparent));
}

.hero-estrut-promo__body {
  flex: 1;
  min-width: 0;
  max-width: 22rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.hero-estrut-promo__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--accent-primary, #6366f1) 78%, var(--text-secondary));
}

.hero-estrut-promo__eyebrow-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.55);
}

.hero-estrut-promo__title {
  margin: 0 0 8px;
  font-size: clamp(1.125rem, 1.6vw, 1.35rem);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.hero-estrut-promo__title-accent {
  display: block;
  margin-top: 2px;
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 55%, #ec4899 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hero-estrut-promo__text {
  margin: 0 0 14px;
  font-size: 0.875rem;
  line-height: 1.6;
  color: var(--text-secondary);
}

.hero-estrut-promo__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 7px 12px 7px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: color-mix(in srgb, var(--accent-primary, #6366f1) 88%, var(--text-primary));
  background: color-mix(in srgb, var(--accent-primary, #6366f1) 10%, var(--bg-primary));
  border: 1px solid color-mix(in srgb, var(--accent-primary, #6366f1) 22%, var(--border-primary));
  box-shadow: 0 2px 12px color-mix(in srgb, var(--accent-primary, #6366f1) 8%, transparent);
}

.hero-estrut-promo__badge svg {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  opacity: 0.9;
}

.hero-estrut-promo__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
  text-decoration: none;
  color: #fff;
  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 50%, #9333ea 100%);
  box-shadow:
    0 4px 16px rgba(99, 102, 241, 0.38),
    0 1px 0 rgba(255, 255, 255, 0.12) inset;
  transition: transform 0.18s ease, box-shadow 0.18s ease, gap 0.18s ease;
}

.hero-estrut-promo__btn-icon {
  width: 18px;
  height: 18px;
  transition: transform 0.18s ease;
}

.hero-estrut-promo__btn:hover {
  transform: translateY(-2px);
  gap: 14px;
  box-shadow:
    0 8px 28px rgba(99, 102, 241, 0.48),
    0 1px 0 rgba(255, 255, 255, 0.14) inset;
}

.hero-estrut-promo__btn:hover .hero-estrut-promo__btn-icon {
  transform: translateX(3px);
}

.hero-estrut-promo__btn:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--accent-primary, #6366f1) 65%, white);
  outline-offset: 3px;
}

.hero-brand {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  max-width: 546px;
  justify-self: end;
  align-self: start;
}

.hero-logo-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  max-height: 468px;
  padding: 0;
}

.hero-logo {
  width: auto;
  max-width: 100%;
  max-height: 468px;
  height: auto;
  object-fit: contain;
  object-position: right center;
  display: block;
  margin-left: auto;
  filter: drop-shadow(0 10px 26px rgba(15, 23, 42, 0.24));
}

.hero-stats {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: auto;
  padding-top: 32px;
  padding-right: 32px;
}

.hero-stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 4px;
  background: color-mix(in srgb, var(--bg-primary) 82%, transparent);
  border: 1px solid var(--border, var(--border-primary));
  backdrop-filter: blur(8px);
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.hero-stat-card:hover {
  transform: translateY(-2px);
  border-color: color-mix(in srgb, #6366f1 35%, var(--border, var(--border-primary)));
}

.hero-stat-value--plan {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
}

.hero-stat-plan-sub {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8b5cf6;
}

.hero-stat-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-stat-icon--indigo {
  background: rgba(99, 102, 241, 0.14);
  color: #6366f1;
}

.hero-stat-icon--violet {
  background: rgba(139, 92, 246, 0.14);
  color: #8b5cf6;
}

.hero-stat-body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.hero-stat-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.hero-stat-value {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1.2;
}

.hero-stat-value--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.workspace-panel {
  border-radius: 4px;
  padding: 26px 28px 24px;
  background: var(--bg-secondary);
  border: 1px solid var(--border, var(--border-primary));
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);
}

.workspace-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border, var(--border-primary));
}

.workspace-panel-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.workspace-panel-icon {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #6366f1;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.18), rgba(139, 92, 246, 0.08));
  border: 1px solid rgba(99, 102, 241, 0.22);
}

.workspace-panel-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.workspace-panel-subtitle {
  margin: 4px 0 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.workspace-count-badge {
  flex-shrink: 0;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
  border: 1px solid rgba(99, 102, 241, 0.22);
}

.workspace-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.workspace-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  min-height: 260px;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--tile-accent) 22%, var(--border, var(--border-primary)));
  background: var(--bg-primary);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.workspace-card:hover {
  transform: translateY(-4px);
  border-color: color-mix(in srgb, var(--tile-accent) 45%, var(--border, var(--border-primary)));
  box-shadow: 0 12px 32px color-mix(in srgb, var(--tile-accent) 18%, transparent);
}

.workspace-card--active {
  border-color: color-mix(in srgb, var(--tile-accent) 55%, var(--border, var(--border-primary)));
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--tile-accent) 25%, transparent),
    0 12px 28px color-mix(in srgb, var(--tile-accent) 22%, transparent);
}

.workspace-card__media {
  flex-shrink: 0;
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    145deg,
    color-mix(in srgb, var(--tile-accent) 28%, var(--bg-secondary)),
    color-mix(in srgb, var(--tile-accent) 8%, var(--bg-primary))
  );
  box-shadow: none;
}

.workspace-card__photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.workspace-card__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 14px 16px 12px;
}

.workspace-card__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.workspace-card__badge {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.workspace-card__badge--crm {
  color: #059669;
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.25);
}

.workspace-card__badge--task {
  color: #4f46e5;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
}

.workspace-card__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: auto;
  padding: 12px 16px 16px;
  border-top: 1px solid color-mix(in srgb, var(--tile-accent) 12%, var(--border, var(--border-primary)));
  color: color-mix(in srgb, var(--tile-accent) 75%, #4f46e5);
  background: color-mix(in srgb, var(--tile-accent) 6%, var(--bg-secondary));
  transition: background 0.2s ease, color 0.2s ease;
}

.workspace-card:hover .workspace-card__footer {
  color: #fff;
  background: linear-gradient(135deg, var(--tile-accent), color-mix(in srgb, var(--tile-accent) 70%, #7c3aed));
  border-top-color: transparent;
}

.workspace-card__cta {
  font-size: 13px;
  font-weight: 700;
}

.workspace-gallery-hint {
  margin: 0 0 14px;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.workspace-card--create {
  border-style: dashed;
  border-color: color-mix(in srgb, #6366f1 35%, var(--border, var(--border-primary)));
  background: var(--bg-primary);
}

.workspace-card--create:hover {
  border-color: color-mix(in srgb, #6366f1 55%, var(--border, var(--border-primary)));
  border-style: dashed;
}

.workspace-card--create-disabled,
.workspace-card--create-disabled:hover {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
  border-color: var(--border-primary);
}

.workspace-card__media--create {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    165deg,
    color-mix(in srgb, #6366f1 14%, var(--bg-secondary)),
    var(--bg-primary)
  );
}

.workspace-card-create-icon {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 4px;
  color: color-mix(in srgb, #6366f1 70%, var(--text-secondary));
  background: color-mix(in srgb, var(--bg-primary) 88%, transparent);
  border: 2px solid color-mix(in srgb, #6366f1 28%, var(--border, var(--border-primary)));
  box-shadow:
    0 4px 12px rgba(15, 23, 42, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition: color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.workspace-card--create:hover .workspace-card-create-icon {
  color: #6366f1;
  border-color: color-mix(in srgb, #6366f1 50%, var(--border, var(--border-primary)));
  transform: scale(1.05);
}

.workspace-card-create-glow {
  position: absolute;
  inset: 0;
  opacity: 0;
  background: radial-gradient(circle at 50% 50%, rgba(99, 102, 241, 0.22) 0%, transparent 70%);
  transition: opacity 0.25s ease;
  pointer-events: none;
}

.workspace-card--create:hover .workspace-card-create-glow {
  opacity: 1;
}

.workspace-card__badge--new {
  color: #6366f1;
  background: rgba(99, 102, 241, 0.12);
  border: 1px solid rgba(99, 102, 241, 0.25);
}

.workspace-card__footer--create {
  color: #6366f1;
  background: color-mix(in srgb, #6366f1 8%, var(--bg-secondary));
  border-top-color: color-mix(in srgb, #6366f1 15%, var(--border, var(--border-primary)));
}

.workspace-card--create:hover .workspace-card__footer--create {
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border-top-color: transparent;
}

.workspace-empty {
  text-align: center;
  padding: 48px 24px;
  border-radius: 4px;
  border: 1px dashed var(--border, var(--border-primary));
  background: color-mix(in srgb, var(--bg-primary) 60%, transparent);
}

.workspace-empty__icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  background: var(--bg-primary);
  border: 1px solid var(--border, var(--border-primary));
}

.workspace-empty__title {
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-primary);
}

.workspace-empty__text {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

@media (max-width: 1024px) {
  .dashboard-hero {
    min-height: 0;
    padding: 28px 24px 24px;
  }

  .hero-grid {
    grid-template-columns: 1fr;
    min-height: 0;
    flex: none;
    padding-right: 0;
    text-align: center;
  }

  .hero-brand {
    max-width: none;
    margin: 20px auto 0;
    justify-content: center;
    justify-self: center;
  }

  .hero-logo-wrap {
    justify-content: center;
    height: auto;
    max-height: 286px;
  }

  .hero-logo {
    max-height: 286px;
    margin-left: auto;
    margin-right: auto;
    object-position: center;
  }

  .hero-copy {
    padding-right: 0;
    text-align: center;
  }

  .hero-stats {
    padding-right: 0;
  }

  .hero-subtitle {
    margin-left: auto;
    margin-right: auto;
  }

  .hero-chips {
    justify-content: center;
  }

  .hero-estrut-promo {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }

  .hero-estrut-promo__visual {
    align-self: center;
  }

  .hero-estrut-promo__body {
    align-items: center;
    max-width: none;
    text-align: center;
  }

  .hero-estrut-promo__eyebrow {
    justify-content: center;
  }

  .hero-estrut-promo__title-accent {
    display: inline;
  }

  .hero-estrut-promo__body .hero-estrut-promo__btn {
    align-self: center;
    width: auto;
    max-width: 100%;
  }

  .hero-stats {
    grid-template-columns: 1fr;
  }

  .workspace-panel-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .dashboard-page {
    padding: 16px;
  }

  .dashboard-hero {
    padding: 24px 18px 20px;
  }

  .workspace-gallery {
    grid-template-columns: 1fr;
  }
}
</style>